import { useMemo, useState } from 'preact/hooks'
import { useAthosContext } from '../fetchers/provider'
import { ResultsCard } from './ResultCard'
import { useBeaconLogImpressions, useBeaconLogRender } from '../hooks/useBeaconAnalytics'

export function QuickSearchResults({ parentResults }) {
  const { results } = useAthosContext()
  const [beaconNode, setBeaconNode] = useState()

  useBeaconLogRender()
  useBeaconLogImpressions(beaconNode)

  const products = useMemo(() => {
    if (parentResults) {
      return parentResults?.results
    }
    return results?.results
  }, [parentResults, results])

  if (products?.length === 0) return null

  return (
    <div ref={setBeaconNode} className="grid w-full grid-cols-2 gap-2 overflow-x-scroll shrink-0 md:grid-cols-4">
      {products?.map((result, index) => (
        <ResultsCard
          key={result.handle}
          wishlist={{ type: 'none' }}
          result={result}
          index={index}
          className="shrink-0 basis-1/2 md:shrink md:basis-1/4"
        />
      ))}
    </div>
  )
}
